export const environment = {
  production: true,
  "apiURL": "https://test.api-gateway.mycargoservices.net/api/v3/",
  "apiURLV1": "https://test.api-gateway.mycargoservices.net/v1/",
  "tarifURL": "https://test.api-gateway.mycargoservices.net/tarifierung/v1/",
  "storageURL": "https://test.api-gateway.mycargoservices.net/storage/v1/",
  "printURL": "http://localhost:8791/v1/",
  "readerURL": "https://test.api-gateway.mycargoservices.net/reader/v1/",
  "exportDEToken": "a528bdce-a286-4a39-a4a1-07a4cf2e97b7", //asendia(aasImport)
  "storageToken": "8649e207-e5ce-4f72-b7ab-c19ae06eb7b0",  //storage@SysAdminGroup
  "aasMandantToken": "1904f7dc-daaf-4cc8-b55e-6a200e279fb4",
  "InfoEmail": "cs@mycargogate.com"
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/environments/environment.ts